import React, { useState, useEffect } from 'react';
import { Button, TextField, Grid, Box, Typography, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { API_ENDPOINTS } from '../../utils/config';
import "./Grid.css";

const GridMapEditor = (props) => {
  const [isDrawing, setIsDrawing] = useState(false);
  const [toggleMode, setToggleMode] = useState('obstacle');

  const [currentRows, setCurrentRows] = useState(20);
  const [currentCols, setCurrentCols] = useState(20);
  const [rows, setRows] = useState(20);
  const [cols, setCols] = useState(20);
  const [gridMap, setGridMap] = useState(Array.from({ length: 20 }, () => Array.from({ length: 20 }, () => 0)));
  const [greenCells] = useState({})
  const [isModified, setIsModified] = useState(false);
  const [isEndPointPrompt, setIsEndPointPrompt] = useState(false);
  const [greenCounter, setGreenCounter] = useState(100);
  const [redCounter, setRedCounter] = useState(500);

  useEffect(() => {
    setIsModified(currentRows !== rows || currentCols !== cols);
  }, [currentRows, currentCols, rows, cols]);

  useEffect(() => {
    if (typeof props.onShapeChange === 'function') {
      props.onShapeChange(rows, cols);
    }
  }, [rows, cols]); // eslint-disable-line react-hooks/exhaustive-deps

  // Update grid when solvedGrid prop changes
  useEffect(() => {
    if (props.solvedGrid && Array.isArray(props.solvedGrid)) {
      const solvedGrid = props.solvedGrid;
      setRows(solvedGrid.length);
      setCols(solvedGrid[0].length);
      setCurrentRows(solvedGrid.length);
      setCurrentCols(solvedGrid[0].length);
      setGridMap(solvedGrid);
    }
  }, [props.solvedGrid]);

  const countGreenCells = () => gridMap.flat().filter(cell =>cell >100 & cell<499).length;
  const countRedCells = () => gridMap.flat().filter(cell => cell >499 & cell<999).length;

  const initializeGridMap = () => {
    setRows(currentRows);
    setCols(currentCols);
    setGridMap(Array.from({ length: currentRows }, () => Array.from({ length: currentCols }, () => 0)));
  };


  const resetGrid=()=>{
    setCols(20)
    setRows(20)
    setCurrentRows(20)
    setCurrentCols(20)

    setGridMap(Array.from({ length: 20 }, () => Array.from({ length: 20 }, () => 0)))

  }



  const handleCellClick = (row, col, isRightClick = false) => {
    const updatedGridMap = [...gridMap];
    
    if (toggleMode === "start_point" && isEndPointPrompt && !isRightClick) {
      alert('Right-click to place the goal.');
      return;
    }

    if (updatedGridMap[row][col] === 0) {
      if (toggleMode === 'start_point' && countGreenCells() > countRedCells() && !isRightClick) {
        setIsEndPointPrompt(true);
        alert('Right-click a cell for the goal.');
        return;
      }
      if (toggleMode==="start_point" && countGreenCells()<=countRedCells() && isRightClick){

        alert('Place a start first, then right-click for the goal.');
        return 

      }
      if (isRightClick && toggleMode==="start_point") {
        updatedGridMap[row][col] = redCounter+1; 
        setRedCounter(prev => prev + 1);
        setIsEndPointPrompt(false);
      } else {
        updatedGridMap[row][col] = toggleMode === 'obstacle' ? 9999 : greenCounter+1;
        setGreenCounter(prev => prev + 1);
      }
    } else {
      updatedGridMap[row][col] = 0;
    }

    setGridMap(updatedGridMap);
  };

  const handleMouseDown = (row, col, event) => {
    
    if (toggleMode==="obstacle"){
      setIsDrawing(true);
    }else{
      setIsDrawing(false);
    }
    handleCellClick(row, col, event.button === 2); 
  };

  const handleMouseEnter = (row, col) => {
    if (isDrawing) {
      handleCellClick(row, col);
    }
  };

  const handleMouseUp = () => {
    setIsDrawing(false);
  };

  
  const handleDownload = () => {
    const jsonMap = JSON.stringify(gridMap);
    console.log(jsonMap)
    const blob = new Blob([jsonMap], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'grid_map.json';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const gridSolver = async () => {
    if (typeof props.onGridSolve === 'function') {
      props.onGridSolve(gridMap);
      return;
    }

    if (typeof props.onSolve === 'function') {
      props.onSolve(gridMap);
      return;
    }

    // Fallback when no parent handler is wired
    const jsonMap = JSON.stringify(gridMap);
    try {
      const response = await fetch(API_ENDPOINTS.MOBILITY_SOLVE_GRID, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: jsonMap,  // Sending the grid map as JSON
      });
      const responseData = await response.json();
      // console.log('Server Response:', responseData);  

      const solvedGrid=responseData['solved_grid']
      setRows(solvedGrid.length);
      setCols(solvedGrid[0].length);
      setGridMap(solvedGrid);
    } catch (error) {
      console.error('Error uploading grid map:', error);
    }
  };
  function getRandomColor() {
    let randomColor;
    
    function isForbiddenColor(color) {
        // Extract RGB components from the hexadecimal color
        const r = parseInt(color.slice(1, 3), 16);
        const g = parseInt(color.slice(1, 5).slice(-2), 16);
        const b = parseInt(color.slice(1).slice(-2), 16);
        
        // Check for shades of black
        const isBlack = (r < 50 && g < 50 && b < 50);
        
        // Check for shades of red (high red value, low green and blue values)
        const isRed = (r > 150 && g < 80 && b < 80);
        
        // Check for shades of green (high green value, low red and blue values)
        const isGreen = (g > 150 && r < 80 && b < 80);
        
        return isBlack || isRed || isGreen;
    }

    do {
        // Generate a random number between 0 and 16777215 (0xFFFFFF)
        const randomNumber = Math.floor(Math.random() * 16777215);

        // Convert the number to a hexadecimal string and pad with leading zeros if necessary
        randomColor = `#${randomNumber.toString(16).padStart(6, '0')}`;
    } while (isForbiddenColor(randomColor)); // Repeat if the color is a shade of black, red, or green
    
    console.log(randomColor);
    return randomColor;
}


  const handleStartCells=(cell)=>{

    if (cell in greenCells){
      // console.log('found',  greenCells[cell])
      return greenCells[cell]
    }else{
      greenCells[cell]=getRandomColor()
      // console.log('not found' , greenCells.cell)
      return greenCells[cell]

    }


  }



  const renderGridMap = () => {
    const gridContainerSize = 500;
    return (
      <div
        className="grid-container"
        style={{
          gridTemplateColumns: `repeat(${cols}, 1fr)`,
          gridTemplateRows: `repeat(${rows}, 1fr)`,
          width: `100%`,
          height: `${gridContainerSize}px`,
          border: '1px solid #333',
          borderRadius: 12,
          overflow: 'hidden',
          background: '#0d1216',
        }}
      >
        {gridMap.flat().map((cell, index) => (
          <div
            key={index}
            onMouseDown={(e) => handleMouseDown(Math.floor(index / cols), index % cols, e)}
            onMouseEnter={() => handleMouseEnter(Math.floor(index / cols), index % cols)}
            onMouseUp={handleMouseUp}
            onContextMenu={(e) => e.preventDefault()} 
            style={{
              backgroundColor:
                cell === 9999
                  ? '#3a1515'
                  : cell > 100 && cell < 499
                    ? 'rgba(44,187,93,0.85)'
                    : cell > 499 && cell < 999
                      ? 'rgba(239,71,67,0.85)'
                      : cell === 0
                        ? '#1a2228'
                        : handleStartCells(cell),
              boxShadow:
                cell === 9999
                  ? 'inset 0 0 8px rgba(239,71,67,0.55), 0 0 4px rgba(239,71,67,0.35)'
                  : cell === 0
                    ? 'inset 0 0 6px rgba(44,187,93,0.12)'
                    : undefined,
              border:
                cell === 9999
                  ? '1px solid #ef4743'
                  : cell === 0
                    ? '0.5px solid rgba(44,187,93,0.25)'
                    : '0.5px solid #222',
              width: '100%',
              height: '100%',
              boxSizing: 'border-box',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              color: '#fff',
              fontSize: 11,
              fontWeight: 700,
            }}
            
          >

            {cell >= 101 && cell < 499 ? cell-100 : cell >= 501 && cell < 999 ? cell-500 : ''}
            </div>
          
        ))}
      </div>
    );
  };


  

  return (
    <div className='main'>
      <Box sx={{ padding: 1, borderRadius: 2, maxWidth: 640, ml: 0, mt: 1 }}>
        <Typography variant="subtitle2" gutterBottom sx={{ color: '#2cbb5d', letterSpacing: 1 }}>
          Size
        </Typography>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={3}>
            <TextField
              label="Rows"
              type="number"
              value={currentRows}
              onChange={(e) => setCurrentRows(parseInt(e.target.value, 10))}
              variant="outlined"
              size="small"
              fullWidth
              InputLabelProps={{ style: { color: '#a1a1aa' } }}
              InputProps={{ style: { color: '#fff' } }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  '& fieldset': { borderColor: '#333' },
                  '&:hover fieldset': { borderColor: '#2cbb5d' },
                  '&.Mui-focused fieldset': { borderColor: '#2cbb5d' },
                },
              }}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              label="Cols"
              type="number"
              value={currentCols}
              onChange={(e) => setCurrentCols(parseInt(e.target.value, 10))}
              variant="outlined"
              size="small"
              fullWidth
              InputLabelProps={{ style: { color: '#a1a1aa' } }}
              InputProps={{ style: { color: '#fff' } }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  '& fieldset': { borderColor: '#333' },
                  '&:hover fieldset': { borderColor: '#2cbb5d' },
                  '&.Mui-focused fieldset': { borderColor: '#2cbb5d' },
                },
              }}
            />
          </Grid>
          <Grid item xs={5} >
            {isModified && 
              <Button
                variant="contained"
                onClick={initializeGridMap}
                fullWidth
                sx={{
                  backgroundColor: '#2cbb5d',
                  '&:hover': { backgroundColor: '#249a4d' },
                  color: '#000',
                  fontWeight: 700,
                  textTransform: 'none',
                }}
              >
                Initialize
              </Button>
              
            }
            {!isModified&&
            <Button
                variant="contained"
                onClick={resetGrid}
                fullWidth
                sx={{
                  backgroundColor: '#18181b',
                  border: '1px solid #333',
                  '&:hover': { backgroundColor: '#222', borderColor: '#ef4743' },
                  color: '#a1a1aa',
                  textTransform: 'none',
                }}
              >
                Reset grid
              </Button>
            }
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ padding: 0, maxWidth: 520, ml: 0, mt: 1, mb: 1 }}>
        <FormControl component="fieldset">
          <FormLabel component="legend" sx={{ color: '#a1a1aa', fontSize: 12 }}>Draw</FormLabel>
          <RadioGroup
            aria-label="toggleMode"
            name="toggleMode"
            value={toggleMode}
            onChange={(e) => setToggleMode(e.target.value)}
            row
          >
            <FormControlLabel
              value="obstacle"
              control={<Radio sx={{ color: '#666', '&.Mui-checked': { color: '#a1a1aa' } }} />}
              label={<Typography sx={{ color: '#e4e4e7', fontSize: 14 }}>Obstacle</Typography>}
            />
            <FormControlLabel
              value="start_point"
              control={<Radio sx={{ color: '#666', '&.Mui-checked': { color: '#2cbb5d' } }} />}
              label={<Typography sx={{ color: '#e4e4e7', fontSize: 14 }}>Start / Goal</Typography>}
            />
          </RadioGroup>
        </FormControl>
      </Box>

      <div style={{ display: 'flex', justifyContent: 'left', marginTop: '12px' }}>{renderGridMap()}</div>
      <Box alignItems={"center"} display={"flex"} marginTop={"12px"} gap={1}>
        <Button 
          variant="contained"
          onClick={handleDownload}
          sx={{
            backgroundColor: '#18181b',
            border: '1px solid #333',
            '&:hover': { borderColor: '#2cbb5d', backgroundColor: '#1f1f23' },
            color: '#e4e4e7',
            textTransform: 'none',
          }}
        >
          Download map
        </Button>

        <Button
          variant="contained"
          onClick={gridSolver}
          sx={{
            backgroundColor: '#2cbb5d',
            '&:hover': { backgroundColor: '#249a4d' },
            color: '#000',
            fontWeight: 700,
            textTransform: 'none',
          }}
        >
          Solve grid
        </Button>
      </Box>

      
    </div>  
  );
};

export default GridMapEditor;
